module.exports = __webpack_public_path__ + "img/pe.c73122b9.svg";